import { getLocalTime } from '../time';
export const formatActionItem = ({
  creator,
  title,
  description,
  status,
  dateCreated,
  dueDate,
  assignee,
  workspace,
  __typename,
  id,
  priority,
}) => ({
  id: `${id}`,
  creator: `${creator?.firstName} ${creator?.lastName}`,
  assignee: assignee ? `${assignee?.firstName} ${assignee?.lastName}` : '',
  title: title,
  description: description,
  status: status,
  priority,
  dateCreated: getLocalTime(dateCreated).format('YYYY-MM-DD hh:mm'),
  dueDate: dueDate ? getLocalTime(dueDate).format('YYYY-MM-DD hh:mm') : '',
  workspace: workspace?.title,
  __typename,
});
export const formatAssessment = ({
  creator,
  template,
  dateCreated,
  dateModified,
  notes,
  __typename,
  vehicle,
  id,
  isDraft,
  passed,
  participant,
  workspace,
  reportedWorkspaceTitle,
}) => ({
  id: `${id}`,
  title: template?.title,
  status: isDraft ? 'IN_PROGRESS' : 'COMPLETE',
  type: template?.templateType === 'VEHICLE' ? 'FLEET' : template.templateType,
  passed: passed ? 'TRUE' : 'FALSE',
  vehicle: `${vehicle?.unitNumber || ''}`,
  creator: !!creator
    ? `${creator?.firstName} ${creator?.lastName}`
    : 'Anonymous',
  creatorId: !!creator ? `${creator.id}` : '',
  creatorEmail: creator?.email ?? '',
  workspace: workspace?.title || reportedWorkspaceTitle || 'Shared',
  dateCreated: getLocalTime(dateCreated).format('YYYY-MM-DD hh:mm'),
  dateModified: getLocalTime(dateModified).format('YYYY-MM-DD hh:mm'),
  notes,
  participant,
  allWorkspaces: !!workspace?.id ? 'FALSE' : 'TRUE',
  __typename,
});

export const formatIncident = ({
  creator,
  dateCreated,
  status,
  dateOfIncident,
  location,
  notes,
  __typename,
  vehicle,
  id,
  closedAt,
  title,
  description,
  type,
  subtype,
  lostTimeHrs,
  lostTime,
  nearMiss,
  potentialFatality,
  externalEmployee,
  employee,
  closer,
  workspace,
  externalId,
}) => ({
  id: `${id}`,
  externalId,
  status,
  dateOfIncident,
  location,
  type,
  subtype,
  title,
  description,
  potentialFatality,
  nearMiss,
  lostTime,
  lostTimeHrs,
  employee: !!employee ? `${employee?.firstName} ${employee?.lastName}` : null,
  externalEmployee,
  vehicle: `${vehicle?.unitNumber || ''}`,
  workspace: workspace?.title,
  creator: `${creator?.firstName} ${creator?.lastName}`,
  dateCreated: getLocalTime(dateCreated).format('YYYY-MM-DD hh:mm'),
  closer: !!closer ? `${closer?.firstName} ${closer?.lastName}` : null,
  closedAt: !!closer ? getLocalTime(closedAt).format('YYYY-MM-DD hh:mm') : null,
  notes,
  __typename,
});

export const formatObservation = ({
  creator,
  dateCreated,
  dateTime,
  negative,
  location,
  status,
  notes,
  __typename,
  id,
  dateClosed,
  description,
  reviewer,
  dateReviewed,
  closer,
  workspace,
  externalId,
}) => ({
  id: `${id}`,
  externalId,
  negative: !!negative ? 'Action Required' : 'Positive',
  status,
  dateTime: getLocalTime(dateTime).format('YYYY-MM-DD'),
  location,
  description,
  workspace: workspace?.title,
  creator: !!creator
    ? `${creator?.firstName} ${creator?.lastName}`
    : 'Anonymous',
  dateCreated: getLocalTime(dateCreated).format('YYYY-MM-DD hh:mm'),
  reviewer: !!reviewer ? `${reviewer?.firstName} ${reviewer?.lastName}` : null,
  dateReviewed: !!reviewer
    ? getLocalTime(dateReviewed).format('YYYY-MM-DD hh:mm')
    : null,
  closer: !!closer ? `${closer?.firstName} ${closer?.lastName}` : null,
  dateClosed: !!closer
    ? getLocalTime(dateClosed).format('YYYY-MM-DD hh:mm')
    : null,
  notes,
  __typename,
});

export const formatUser = ({
  id,
  firstName,
  lastName,
  email,
  lastActivity,
  address,
  role,
  city,
  phone,
  postalCode,
  emergencyContact,
  externalActivityId,
  dateOfBirth,
  payrollId,
  workRoles,
}) => ({
  id: `${id}`,
  name: `${firstName} ${lastName}`,
  email: email || 'N/A',
  lastActivity: lastActivity
    ? getLocalTime(lastActivity).format('YYYY-MM-DD hh:mm')
    : 'Never',
  address: address || 'N/A',
  role: role || 'Unassigned',
  city: city || 'N/A',
  phone: phone || 'N/A',
  postalCode: postalCode || 'N/A',
  emergencyContact: emergencyContact || 'N/A',
  externalActivityId: externalActivityId || 'N/A',
  dateOfBirth: dateOfBirth
    ? getLocalTime(dateOfBirth).format('YYYY-MM-DD')
    : 'N/A',
  payrollId: payrollId || 'N/A',
  workRoles: workRoles?.map(({ title }) => title).join(', ') || 'Unassigned',
});

export { excelHeaderLookup } from '@opas-mobile/report-export';
